import { fetchCartSummary } from 'helpers/api';
import { formatMoney } from 'helpers/utils';

const _amountLeft = document.getElementsByClassName('js--ob-amount-left')[0];
const _percent = document.getElementsByClassName('js--ob-percent')[0];
const _shippingSmall = document.getElementsByClassName('js--shipping-small')[0];
const _shippingLTL = document.getElementsByClassName('js--shipping-ltl')[0];
const _freightAmount = document.getElementsByClassName('js--shipping-freight')[0];
const freightContainer = document.getElementsByClassName('js--allowable-freight')[0];
const hide = 'ob__level--hide';

// ==================================================
// INITIALIZERS
// ==================================================

export async function fetchAndHandleAllowableFreight() {
    const { Freight, CartTotal } = await fetchCartSummary();
    const { Target: allowableFreightAmount, IsLTL, Hide = false } = Freight;

    if (!Hide) {
        freightContainer.classList.remove('none');
    } else {
        return freightContainer.classList.add('none');
    }

    const ltlActiveClass = _percent.classList.contains('ob--ltl');

    if (IsLTL && !ltlActiveClass) {
        _percent.classList.add('ob--ltl');
    }
    if (!IsLTL && ltlActiveClass) {
        _percent.classList.remove('ob--ltl');
    }

    _percent.setAttribute('data-allowable-freight', allowableFreightAmount);
    _freightAmount.innerHTML = formatMoney(allowableFreightAmount);
    updateAllowableFreight({ total: 0, summary: { Freight, CartTotal } });
}

// ==================================================
// HANDLERS
// ==================================================

function updateOrderBuilderPercentBar({ CurrentTotal, Target }) {
    const hideClass = 'ob__level--hide';
    const _achievedMessage = document.getElementsByClassName('js--ob-af-achieved')[0];
    const _amountMessage = document.getElementsByClassName('js--ob-af-amount')[0];
    const percentLvl = (CurrentTotal / Target) * 100;
    const percent = percentLvl > 100 ? 100 : percentLvl;
    const difference = Target - CurrentTotal;
    const updatedAmountLeft = difference < 0 ? 0 : difference;
    const messages =
        updatedAmountLeft > 0
            ? [_achievedMessage, _amountMessage]
            : [_amountMessage, _achievedMessage];
    const currentPercent = Number(
        _percent.style.width.substring(0, _percent.style.width.length - 1),
    );

    messages[0].classList.add(hideClass);
    messages[1].classList.remove(hideClass);
    _amountLeft.innerHTML = formatMoney(updatedAmountLeft);
    _percent.style.width = `${percent}%`;
    if (percent > 0) {
        document.getElementsByClassName('ob__level__percent')[0].classList.add('ob__show-truck');
    } else {
        setTimeout(
            () =>
                document
                    .getElementsByClassName('ob__level__percent')[0]
                    .classList.remove('ob__show-truck'),
            2000,
        );
    }
    if (document.getElementsByClassName('ob__show-truck').length) {
        if (percent < currentPercent) {
            document.getElementsByClassName('ob__show-truck')[0].classList.add('reverse-truck');
        } else {
            document.getElementsByClassName('ob__show-truck')[0].classList.remove('reverse-truck');
        }
    }
}

export async function updateAllowableFreight({ total = 0, summary } = {}) {
    if (!document.getElementsByClassName('js--allowable-freight')[0]) {
        return;
    }

    const { Freight } = !summary ? await fetchCartSummary() : summary;
    const { Target, IsLTL, Hide = false } = Freight;

    if (!Hide) {
        freightContainer.classList.remove('none');
    } else {
        return freightContainer.classList.add('none');
    }

    const ltlActiveClass = _percent.classList.contains('ob--ltl');

    if (IsLTL && !ltlActiveClass) {
        _percent.classList.add('ob--ltl');
        _shippingSmall.classList.add(hide);
        _shippingLTL.classList.remove(hide);
    }
    if (!IsLTL && ltlActiveClass) {
        _percent.classList.remove('ob--ltl');
        _shippingLTL.classList.add(hide);
        _shippingSmall.classList.remove(hide);
    }

    if (document.getElementsByClassName('js--ob-total')[0]) {
        updateOrderBuilderPercentBar({ total, CurrentTotal: Freight.CurrentTotal, Target });
    }

    // updateSidecart({ CartTotal, Target })
    _freightAmount.innerHTML = formatMoney(Target);
}

// ==================================================
// HELPERS
// ==================================================

// ==================================================
// INIT
// ==================================================

function init() {
    // fetchAndHandleAllowableFreight()
}

export default init;



// WEBPACK FOOTER //
// ./app/js/modules/allowable-freight-promo.js